/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Controller } from 'react-hook-form';
import {
  FormDialog,
  FormDialogActions,
  FormDialogContent,
  FormDialogTitle,
  FormElement,
  FormInputsStack,
  FormCancelButton,
  FormSubmitButton,
  Inputs,
  InputComboBoxObjectOption,
} from '@marageti/z4-lib';
import { ViewProps } from './types';

const priorityOptions = [{ label: 'Primary', value: true }, { label: 'Secondary', value: false }];

const AddCountryFormView = ({
  control,
  countryOptions,
  errors,
  handleSubmit,
  onCancel,
  onSubmit,
  open,
  register,
  setMinBudgetPPPD,
  partnerCountry,
  defaultBudget,
}: ViewProps) => (
  <FormDialog
    open={open}
  >
    <FormDialogTitle handleClose={onCancel}>
      {partnerCountry ? 'Edit Country' : 'Add Country'}
    </FormDialogTitle>
    <FormElement name="profile-editor-form" onSubmit={handleSubmit(onSubmit)}>
      <FormDialogContent>
        <FormInputsStack>
          <Controller
            control={control}
            name="country"
            render={({ field }) => (
              <InputComboBoxObjectOption
                  // Open question if we allow the country to change when editing
                  // disabled={!!partnerCountry}
                error={!!errors?.country}
                helperText={errors?.country?.message as string}
                id="country"
                label="Country"
                options={countryOptions}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                {...field}
                onChange={(_: any, data:any) => {
                  setMinBudgetPPPD(data);
                  field.onChange(data);
                }}
                value={field.value || null}
              />
            )}
            rules={{ required: 'Please select a country' }}
          />
          <Controller
            control={control}
            name="primary"
            render={({ field }) => (
              <Inputs.Select
                error={!!errors?.primary}
                id="primary"
                label="Country Priority"
                options={priorityOptions}
                required
                {...field}
                value={field.value ?? ''}
              />
            )}
            rules={{ validate: (v) => v === true || v === false }}
          />
          <Inputs.Number
            defaultValue={defaultBudget}
            error={!!errors?.minBudgetPPPD}
            helperText={errors?.minBudgetPPPD && errors?.minBudgetPPPD.message as string}
            id="minBudgetPPPD"
            label="Minimum Matching Budget (PPPD)"
            startAdornment={<Inputs.Adornment position="start">$</Inputs.Adornment>}
            {...register('minBudgetPPPD', {
              min: 0,
              valueAsNumber: true,
              validate: (value) => {
                if (value < 1 || Number.isNaN(value)) {
                  return 'Required';
                }
                return true;
              },
            })}
          />
        </FormInputsStack>
      </FormDialogContent>
      <FormDialogActions>
        <FormCancelButton onClick={onCancel} />
        <FormSubmitButton>
          {partnerCountry ? 'Submit' : 'Add Country'}
        </FormSubmitButton>
      </FormDialogActions>
    </FormElement>
  </FormDialog>
);

export default AddCountryFormView;
